export default __webpack_public_path__ + "static/media/red-landing.2668dd32.webp";